var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { Fragment } from "react";
import { Client } from ".";
import { classNames } from "./utils/classNames";
import { setIcon } from "./utils/icons";
import { useThemeContext } from "./theming/useThemeContext";
import { useIconWithTextClasses, usePrependAppendStatusLabelClasses, useStatusLabelBodyClasses, useStatusLabelClasses, } from "./StatusLabel/StatusLabel.styles";
export var StatusLabel = function (props) {
    var _a;
    var client = useThemeContext().client;
    var append = props.append, prepend = props.prepend;
    var classes = useStatusLabelClasses(getDefaultComponentSize(client, props === null || props === void 0 ? void 0 : props.size), !!(prepend || append), props === null || props === void 0 ? void 0 : props.color);
    return (React.createElement("span", { className: classNames("status-label", props === null || props === void 0 ? void 0 : props.color, (props === null || props === void 0 ? void 0 : props.extraClass) || "", classes.statusLabel), "data-id": props === null || props === void 0 ? void 0 : props.dataId, "data-testid": props === null || props === void 0 ? void 0 : props.dataTestId, role: (_a = props === null || props === void 0 ? void 0 : props.role) !== null && _a !== void 0 ? _a : undefined, "data-hook": props === null || props === void 0 ? void 0 : props.dataHook, "data-size": props === null || props === void 0 ? void 0 : props.size },
        prepend && React.createElement(StatusLabelPrepend, __assign({}, props)),
        React.createElement(StatusLabelBody, __assign({}, props)),
        append && React.createElement(StatusLabelAppend, __assign({}, props))));
};
var StatusLabelPrepend = function (props) {
    var client = useThemeContext().client;
    var classes = usePrependAppendStatusLabelClasses(getDefaultComponentSize(client, props.size), props === null || props === void 0 ? void 0 : props.color);
    return (React.createElement("span", { className: classNames("status-label--prepend", classes.prepend) }, props === null || props === void 0 ? void 0 : props.prepend));
};
var StatusLabelBody = function (props) {
    var client = useThemeContext().client;
    var text = props.text, glyph = props.glyph, size = props.size;
    var prependAppend = !!((props === null || props === void 0 ? void 0 : props.prepend) || (props === null || props === void 0 ? void 0 : props.append));
    var additionalText = useStatusLabelBodyClasses(!!glyph, prependAppend).additionalText;
    if (prependAppend) {
        return (React.createElement("span", { className: classNames("status-label--text", additionalText) },
            React.createElement(StatusLabelContent, { message: text, glyph: glyph, iconSize: getDefaultComponentSize(client, size), description: props === null || props === void 0 ? void 0 : props.description })));
    }
    return (React.createElement(StatusLabelContent, { message: text, glyph: glyph, iconSize: getDefaultComponentSize(client, size), description: props === null || props === void 0 ? void 0 : props.description }));
};
var StatusLabelAppend = function (props) {
    var client = useThemeContext().client;
    var classes = usePrependAppendStatusLabelClasses(getDefaultComponentSize(client, props.size), props === null || props === void 0 ? void 0 : props.color);
    return (React.createElement("span", { className: classNames("status-label--append", classes.append) }, props === null || props === void 0 ? void 0 : props.append));
};
var StatusLabelContent = function (_a) {
    var message = _a.message, glyph = _a.glyph, glyphColor = _a.glyphColor, iconSize = _a.iconSize, description = _a.description;
    var _b = setIcon(glyph), iconType = _b.iconType, iconValue = _b.iconValue;
    var classes = useIconWithTextClasses(iconSize, iconType);
    if (!glyph)
        return (React.createElement(Fragment, null,
            message,
            description && (React.createElement("span", { className: classNames(classes.srOnly, "pl-2") },
                " ",
                description))));
    return (React.createElement("span", { className: classNames("status-label--icon-wrapper", classes.wrapper) },
        React.createElement("span", { style: { color: glyphColor }, className: classNames("status-label--icon", classes.icon, iconType !== null && iconType !== void 0 ? iconType : "", "".concat(iconType, "-").concat(iconValue)) }),
        React.createElement("span", { className: "status-label--text ".concat(classes.message) },
            message,
            description && (React.createElement("span", { className: classNames(classes.srOnly, "pl-2") },
                " ",
                description)))));
};
export var getDefaultComponentSize = function (client, size) { return size !== null && size !== void 0 ? size : (client === Client.Portal ? "small" : "medium"); };
